import React from 'react';
import { OneTimeSchedule } from '@glueapp/graph-types';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ScheduleEditorProps {
    value: OneTimeSchedule;
    onChange: (updatedSchedule: OneTimeSchedule) => void;
}

function formatDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    const monthText = month < 10 ? '0' + month : month;
    const dayText = day < 10 ? '0' + day : day;
    const hoursText = hours < 10 ? '0' + hours : hours;
    const minutesText = minutes < 10 ? '0' + minutes : minutes;
    const secondsText = seconds < 10 ? '0' + seconds : seconds;

    return `${year}-${monthText}-${dayText}T${hoursText}:${minutesText}:${secondsText}`;
}

export const OneTimeInput: React.FC<ScheduleEditorProps> = ({ value, onChange }) => {
    const utcToLocal = (isoString: string) => {
        const date = new Date(isoString);
        const offset = date.getTimezoneOffset() * 60000;
        return formatDate(new Date(date.getTime() - offset));
    };

    const localToUTC = (localDateTimeString: string) => {
        const date = new Date(localDateTimeString);
        const offset = date.getTimezoneOffset() * 60000;
        return formatDate(new Date(date.getTime() + offset));
    };

    const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const utcDateTime = localToUTC(event.target.value);
        onChange({ ...value, dateTime: utcDateTime });
    };

    return (
        <div className="flex flex-col gap-1.5">
            <Label className="text-xs">Date and Time</Label>
            <Input type="datetime-local" value={utcToLocal(value.dateTime)} onChange={handleDateTimeChange} />
            <span className="text-xs text-muted-foreground">{Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
        </div>
    );
};
